import { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../supabase';
 
// Genera o recupera un session_id persistente per la sessione del browser
function getSessionId() {
  let sessionId = sessionStorage.getItem('jobbetty_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('jobbetty_session_id', sessionId);
  }
  return sessionId;
}
 
// Funzione di logging riutilizzabile, anche fuori dal componente React
export async function trackEvent(eventName, metadata = {}) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
 
    const { error } = await supabase.from('events').insert([
      {
        user_id: user ? user.id : null,
        session_id: getSessionId(),
        event_name: eventName,
        page_path: window.location.pathname,
        metadata,
      },
    ]);
 
    if (error) {
      console.error('Errore tracking evento:', error);
    }
  } catch (err) {
    console.error('Errore tracking evento:', err);
  }
}
 
// Hook da richiamare una sola volta, in cima all'app (es. in App.js)
// Traccia automaticamente un page_view ad ogni cambio di route
export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef(null);
 
  useEffect(() => {
    // Evita doppio log se il path non è realmente cambiato
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
 
    trackEvent('page_view', { path: location.pathname });
  }, [location.pathname]);
}
 
// Hook di comodo per usare trackEvent dentro qualsiasi componente
export function useTrackEvent() {
  return useCallback((eventName, metadata = {}) => {
    trackEvent(eventName, metadata);
  }, []);
}
 